import { createFileRoute } from "@tanstack/react-router";
import AdminVerifyPage from "@/admin/pages/verify";

const TABS = new Set(["phone", "failures", "email"]);

type AdminVerifySearch = {
  tab?: "phone" | "failures" | "email";
};

export const Route = createFileRoute("/admin/verify")({
  component: AdminVerifyPage,
  validateSearch: (search: Record<string, unknown>): AdminVerifySearch => ({
    tab:
      typeof search.tab === "string" && TABS.has(search.tab)
        ? (search.tab as AdminVerifySearch["tab"])
        : undefined,
  }),
});
